import { PropsWithChildren, Component, ErrorInfo } from 'react'

import {
  onErrorHandler,
  ErrorHandlerErrorType,
  ErrorHandlerDataType,
} from './onErrorHandler'

// Global handler for app errors
function handleAppError(
  error: ErrorHandlerErrorType,
  data?: ErrorHandlerDataType,
) {
  onErrorHandler(error, data)
}

export function AppErrorHandler({ children }: PropsWithChildren) {
  return (
    <AppErrorBoundary onError={handleAppError}>{children}</AppErrorBoundary>
  )
}

interface AppErrorBoundaryProps extends PropsWithChildren {
  onError: (error: ErrorHandlerErrorType, data?: ErrorHandlerDataType) => void
}

class AppErrorBoundary extends Component<AppErrorBoundaryProps> {
  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(
    error: ErrorHandlerErrorType,
    { componentStack }: ErrorInfo,
  ) {
    this.props.onError(error, { componentStack })
  }

  render() {
    return this.props.children
  }
}
